<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
      <a-card>
        <div slot="title"><a-icon type="file-search" />&nbsp;Search</div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search v-model="search" placeholder="Quick Search" />
          </li>
          <li>
            <a-collapse :activeKey="getScreen ? 0 : 1">
              <a-collapse-panel key="1">
                <span slot="header">Search More...</span>
                <div class="m-form-item-wrapper">
                  <label>Transaction Date</label>
                  <a-range-picker
                    :placeholder="['Start Date', 'End Date']"
                    v-model="transactionDt"
                    :format="dateFormat"
                  />
                </div>
                <div class="m-form-item-wrapper">
                  <label>Month-Year</label>
                  <a-month-picker
                    placeholder="Select Month-Year"
                    :format="'MM-YYYY'"
                    picker="month"
                    :allowClear="true"
                    v-model="masa"
                  />
                </div>

                <div class="m-form-item-wrapper">
                  <label>SPT Result</label>
                  <a-select
                    placeholder="Select SPT Result"
                    v-model="status"
                    class="width-full"
                    initialValue="undefined"
                    allowClear
                  >
                    <a-select-option value="Kurang Bayar">Insufficient Payment</a-select-option>
                    <a-select-option value="Lebih Bayar">Over Payment</a-select-option>
                  </a-select>
                </div>

                <!-- <div class="m-form-item-wrapper">
                  <label>Payment Status</label>
                  <a-select
                    placeholder="Ex: Transferred ... "
                    v-model="statusPembayaran"
                    class="width-full"
                    initialValue="null"
                    allowClear
                  >
                    <a-select-option value="transferred">Transferred</a-select-option>
                    <a-select-option value="nottransfered">Not Transferred</a-select-option>
                  </a-select>
                </div>

                <div class="m-form-item-wrapper">
                  <label>Delivery Status</label>
                  <a-select
                    placeholder="Ex: Received ... "
                    v-model="statusPengiriman"
                    class="width-full"
                    initialValue="null"
                    allowClear
                  >
                    <a-select-option value="yet">Not Delivery</a-select-option>
                    <a-select-option value="process">On Process</a-select-option>
                    <a-select-option value="done">Received</a-select-option>
                  </a-select>
                </div> -->
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
      <a-spin
        tip="Your document is being processed, do not leave this page!"
        :spinning="loadings.tab"
      >
        <DataList
            :loading="loading"
            :title="$route.meta.title"
            :disabledCreateEditLink="true"
            manifestLink="SPTManifest"
            :tabbedTransactional="true"
            :dataList="poSearch"
            dataListTitle="List SPT"
            :otherList="poSearch"
            otherListTitle="List SPT Rectification"
        >
          <div slot="titleAdvanced">
              <a-button type="primary" @click="togenerate()">Generate</a-button>
          </div>
          <div slot="actions" slot-scope="item">
            <a-button-group class="margin-top">
              <a-button icon="edit" @click="sptEdit(item)" type="dash" v-if="item.source.rightStatusBesar && item.source.rightStatusBesar != 'Release' && item.source.rightStatusBesar != 'Done'">{{ item.source.rightStatusBesar=='Revised' ? 'Revise' : 'Edit' }}</a-button>
              <a-button icon="delete" @click="sptDelete(item.source.id)" type="danger" v-if="item.source.rightStatusBesar == 'On Process' && item.source.pembetulan_sts=='0'">Delete</a-button>
              <a-button icon="form" type="primary" v-if="item.source.pembetulan_sts == '1' && item.source.rightStatusBesar == 'Done'" @click="sptPembetulan(item)" :loading="loadings.recti">Pembetulan SPT</a-button>
            </a-button-group>
          </div>
        </DataList>
      </a-spin>
    </a-col>
  </a-row>
</template>


<script>
import axios from "axios";
import { mapGetters } from "vuex";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import GlobalMethod from "@/mixins/GlobalMethod";
import moment from "moment";
import _ from "lodash";

export default {
  name: "ListMonitoringSPT",
  mixins: [CurrencyFormat, GlobalMethod],
  data() {
    return {
      loading: false,
      dateFormat: "DD-MM-YYYY",
      sptList: [],
      basedList: [],
      search: undefined,
      tempList: "",
      status: undefined,
      masa: undefined,
      transactionDt: [],
      form: this.$form.createForm(this),
      pagination: {
        onChange: () => {},
        pageSize: 5,
        size: "small",
      },
      statusPembayaran: undefined,
      statusPengiriman: undefined,
      activeTab: "list",
      loadings: {
        tab: false,
        recti: false,
      },
    };
  },
  created() {
    this.fetchData();
  },
  activated() {
    this.fetchData();
  },
  mounted() {
    this.$watch(() => this.$route.path, (to, from) => {
      //console.log('route path has changed from ' + from + ' to ' + to)
      this.loadings.tab = true;
      this.fetchData(to, from);
    })
    Event.$on("handleCancel", this.canceltrans);
    Event.$on("callbackTab", this.clickTabed);
  },
  beforeDestroy() {
    Event.$off("handleCancel", this.canceltrans);
    Event.$off("callbackTab", this.clickTabed);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
    poSearch: function () {
      var self = this;
      let outputData = this.sptList;

      if (this.status) {
        outputData = _.filter(
          outputData,
          (obj) =>
            obj.keterangan_spt_value &&
            obj.keterangan_spt_value.toLowerCase().indexOf(this.status.toLowerCase()) >= 0
        );
      }

      if (self.masa) {
        console.log(outputData)
        outputData = _.filter(
          outputData,
          (obj) => moment(obj.spt_masa,"MM-YYYY").format("MM-YYYY") == moment(self.masa).format("MM-YYYY")
        );
      }

      if (self.transactionDt.length > 0) {
        let startDt = moment(self.transactionDt[0]).format(
          this.getStandartFormatDate
        );
        let endDt = moment(self.transactionDt[1]).format(
          this.getStandartFormatDate
        );
        outputData = _.filter(
          outputData,
          (obj) => moment(obj.date_create).format(
            this.getStandartFormatDate
          ) >= startDt && moment(obj.date_create).format(
            this.getStandartFormatDate
          ) <= endDt
        );
      }

      if (this.search) {
        outputData = _.filter(
          outputData,
          (obj) =>
            obj.searchQ &&
            obj.searchQ.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }

      return outputData;
    },
  },
  methods: {
    moment,
    fetchData() {
      this.sptList = [];
      axios({
        method: "get",
        url: this.$serviceUrl + "spt/list",
        params: {
          tlc: this.getAuth.username,
          tipe_spt: this.$route.meta.jns,
          tab: (this.activeTab == 'list' ? "list_spt" : "list_spt_rectification"),
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.sptList = [];
          _.forEach(response.data.data, (data) => {
            this.sptList.push({
              title: data.spt_no,
              tipe: this.$route.meta.jns,
              // timeline: JSON.parse(data.status_app),
              // unread: data.unread == "1" ? true : false,
              subdesc: [
                [
                  {
                    label: data.spt_type_label+ " | " + data.spt_masa_label,
                    value: "",
                  },
                ],
                [
                  {
                    label: moment(data.date_create).format(this.getDefaultDateFormat),
                    value: "",
                  },
                ],
                [
                  {
                    label: "Tax Value",
                    value: this.formatCurrency("IDR", data.tax_value),
                  },
                ],
                [
                  {
                    label: "Compensation Value",
                    value: this.formatCurrency("IDR", data.kompensasi_value),
                  },
                ],
                [
                  {
                    label: "SPT Value",
                    value: this.formatCurrency("IDR", data.spt_value),
                  },
                ],
                [
                  {
                    label: "Note",
                    value: data.note,
                  },
                ],
                [
                  {
                    label: "SPT Result",
                    value: data.keterangan_spt_value,
                  },
                ],
              ],
              rightStatusBesar: data.spt_status,
              pembetulan_sts: data.pembetulan_sts,
              // status: data.spt_status,
              id: data.spt_id,
              // cancelStatus: data.cancel_sts
              //   ? data.cancel_sts == 1
              //     ? "Canceled"
              //     : (data.cancel_sts == 2 ? "Unusual":null)
              //   : null,
              // islistPPrevised: data.cancel_sts == 2 ? true:false,
              // receiveStatus: data.delivered,
              // tgl_buat: data.tgl_buat,
              // peruntukan: data.peruntukan,
              searchQ:
                data.spt_no +
                " " +
                data.note +
                " " +
                data.spt_masa_label +
                " " +
                data.keterangan_spt_value +
                " " +
                data.spt_type_label,
              date_create: data.date_create,
              spt_type_label: data.delivered,
              spt_masa: data.spt_masa,
              keterangan_spt_value: data.keterangan_spt_value,
            });
          });
          this.loadings.tab = false;
        })
        .catch((err) => {
          if (!err.response) {
            this.displayMessage("error-connection-refused");
          } else {
            this.loadings.tab = false;
            this.displayMessage("empty-db");
          }
        });
    },
    canceltrans(item) {
      axios({
        method: "post",
        url: this.$serviceUrl + "main/cancel_transaction",
        params: {
          tlc: this.getAuth.username,
        },
        data: {
          tlc: this.getAuth.username,
          jenis_trans: "po",
          id_manifest: item.id,
          code_trans: item.title,
          kode_project: item.kode_project,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.displayMessageValue("successCancel", response.data.message);
          //this.fetchData();
          this.$router.go()
          this.searching;
        })
        .catch((err) => {
          if (!err.response) {
            this.displayMessage("error-connection-refused");
          } else {
            this.loading = false;
            this.displayMessage("empty-db");
          }
        });
    },
    resetFilter() {
      this.search = null;
      this.status = undefined;
      this.masa = undefined;
      this.transactionDt = [];
    },
    clickTabed(val) {
      this.activeTab = val;
      this.loadings.tab = true;
      this.sptList = [];
      this.fetchData();
      this.resetFilter();
    },
    sptEdit(data) {
      this.$router.push({
        name: "SPTEdit",
        params: { id: data.source.id, tipe: data.source.tipe },
      });
    },
    sptPembetulan(data) {
      this.loadings.recti = true;
      this.asyncAxiosPost("spt/pembetulan", "application/json", this.getAuth, { spt_id: data.source.id })
        .then((response) => {
          this.loadings.recti = false;
          this.$router.push({
            name: "SPTEdit",
            params: { id: response.spt_id },
          });
        })
        .catch((err) => {
          this.loadings.recti = false;
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error-other", responses.message);
        });
    },
    sptDelete(id) {
      const that = this;
      this.$confirm({
        title: "Are you sure to delete this data?",
        content: "",
        okText: "Yes",
        cancelText: "No",
        onOk() {
          that.loadings.tab = true;
          that.asyncAxiosDelete(
            "spt",
            "application/json",
            that.getAuth,
            { spt_id: id }
          )
            .then(() => {
              that.loadings.tab = false;
              that.displayMessage("success-del");
              //that.clickTabed(that.tabs.active);
              that.fetchData();
            })
            .catch((err) => {
              that.loadings.tab = false;
              let responses = Object.assign({}, err.response.data);
              that.displayMessageValue("error-other", responses.message);
            });
        },
        onCancel() { },
      });
    },
    togenerate() {
      this.$router.push({
        name: "mon-Tax",
        params: { tabsActive: "needprocess", generate: this.$route.meta.jns },
      });
    }
  },
};
</script>